import { of } from "rxjs";
import {
  distinctUntilKeyChanged,
  filter,
  groupBy,
  mergeMap,
  switchMap,
  map,
} from "rxjs/operators";
import * as THREE from "three";

function getCube(folder) {
  const urls = [
    folder + "px.jpg",
    folder + "nx.jpg",
    folder + "py.jpg",
    folder + "ny.jpg",
    folder + "pz.jpg",
    folder + "nz.jpg",
    // Generator https://jaxry.github.io/panorama-to-cubemap/.
  ];
  const textureCube = new THREE.CubeTextureLoader().load(urls);
  textureCube.format = THREE.RGBFormat;
  textureCube.encoding = THREE.sRGBEncoding;
  return textureCube;
}

export const SceneSystem = (world, { background = 0xffffff } = {}) => {
  const scene = (world.scene = new THREE.Scene());
  const color = new THREE.Color(background);
  scene.background = color.copySRGBToLinear(color);

  const cubemaps = {
    showroom_env: getCube("/cubemap_1/"),
    field_env: getCube("/cubemap_2/"),
  };
  
  scene.environment = world.object3DManager.setObject3D("scene", scene);

  const light = new THREE.DirectionalLight(0xffffff);
  light.position.set(0.25, 1, 0.25);
  scene.add(light);

  const ambient = new THREE.AmbientLight(0x303030);
  scene.add(ambient);

  // Scene stream
  const scene$ = world.data.entity$.pipe(
    groupBy(
      (entity) => entity.id,
      (entity) => entity
    ),
    mergeMap((group$) =>
      group$.pipe(
        filter((entity) => entity.hasOwnProperty("scene") && entity.scene),
        distinctUntilKeyChanged("scene"),

        // insert environment
        switchMap((definition) => {
          if (definition.scene.environment) {
            /* 
            return world.textureManager
              .getTexture$(definition.scene.environment)
              .pipe(map((environment) => ({ definition, environment })));
            */

            // NOTE: This is temp solution ...
            return of({
              definition,
              environment: cubemaps[definition.scene.environment],
            });
          } else {
            return of({ definition });
          }
        })
      )
    )
  );

  scene$.subscribe(({ definition, environment }) => {
    if (definition?.scene?.hasOwnProperty("background")) {
      const color = new THREE.Color(definition.scene.background);
      // renderPass.clearColor = color.copySRGBToLinear(color)
      scene.background = color.copySRGBToLinear(color);
      world.change$.next();
    }

    if (environment) {
      scene.environment = environment;
    }
  });
};

export default SceneSystem;
